const getters = {};

getters.visitors = state => state.visitors;
getters.chart = state => state.chart;

export default getters;



// WEBPACK FOOTER //
// ./src/screens/Metrics/store/getters.js